import posthog from "posthog-js";
import { useEffect } from "react";
import { useLocation } from "react-router";

export function AnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    if (!posthog) {
      return;
    }

    posthog?.capture?.("$pageview", {
      $current_url: window.location.href,
    });
  }, [location]);

  return null;
}
